<template>
    <section class="">
        <div>
            <div class="t-subtitle2 pda-default">
                {{$t('452')}}
                <!-- 상품 정보 -->
            </div>

            <div class="d-flex pdl-8 pdr-8">
                <div class=" pdl-8 pdr-8">
                    <img :src="goodsThumnail" alt="" class="w-100">
                    <!-- 썸네일 : {{goodsThumnail}}} -->
                </div>
                <div class="pdl-8 pdr-8 t-subtitle2 price">
                    {{goodsName}}
                    <div v-if="!isFree()">
                        <span class="t-helper">{{currency}}</span>
                        <span class="t-body1">{{$n(paymentPrice)}}</span>
                        <span class="t-body3 t-line-through-red" v-if="paymentPrice != totalPrice">
                            {{$n(totalPrice)}}
                            <!-- 정가 -->
                        </span>
                    </div>
                    <div class="t-body1" v-else>
                        Free
                    </div>
                </div>

            </div>
            <hr class="divider mgt-16">
            <div class="pda-default">
                <div class="t-subtitle2 ">
                    {{isFree() ? $t('916') : $t('454')}}
                    <!-- 신청인 정보 / 구매자 정보 -->
                </div>

                <div class="mgt-16">
                    <span class="t-body3">
                        {{isFree() ? $t('917') : $t('455')}}
                        <!-- 신청자 / 구매자 -->
                    </span>
                    <span class="t-body1 mgr-20 mgl-20">{{orderMemberName}}</span>
                </div>

                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-16"
                    id="ordererPhoneText"
                    :class="submitState && ordererPhoneInvalidCheck ? 'mdc-text-field--invalid' : ''"
                >
                    <i class="material-icons mdc-text-field__icon">
                        <!-- {{userIdInvalidCheck &&  ? 'warning' : 'check'}} -->
                    </i>
                    <input type="text" class="mdc-text-field__input"
                        maxlength="50" 
                        autocomplete="off"
                        v-model="ordererPhone"
                        id="ordererPhone"
                        name="ordererPhone"
                        v-validate="'required'"
                        ref="ordererPhone"
                    >
                    <!-- v-validate="'required|email'" -->

                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('456')}}
                            <!-- 휴대폰 번호 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>


                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-25"
                    id="ordererEmailText"
                    :class="submitState && ordererEmailInvalidCheck ? 'mdc-text-field--invalid' : ''"
                >
                    <i class="material-icons mdc-text-field__icon">
                        <!-- {{userIdInvalidCheck &&  ? 'warning' : 'check'}} -->
                    </i>
                    <input type="text" class="mdc-text-field__input"
                        maxlength="50" 
                        autocomplete="off"
                        v-model="ordererEmail"
                        id="ordererEmail"
                        name="ordererEmail"
                        v-validate="'required|email'"
                        ref="ordererEmail"
                    >
                    <!-- v-validate="'required|email'" -->

                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('457')}}
                            <!-- E-mail -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-blue2">
                    <span>
                        {{$t('458')}}
                        <!-- 이메일이 다른 경우 수정할 수 있습니다. -->
                    </span>
                </div>

                <div class="mgt-32">
                    <div v-if="isFree()">
                        <button class="mdc-button mdc-button--raised btn-red w-full" @click="requestEnrolment()">
                            {{$t('921')}}
                            <!-- 수강신청 -->
                        </button>
                        
                    
                    </div>

                    <div v-else>
                        <button class="mdc-button mdc-button--raised btn-red w-full" @click="next()">
                            {{$t('459')}}
                            <!-- 결제하기 -->
                        </button>
                        
                    </div>
                </div>

            </div>
        </div>
        
    </section>
</template>

<script>
/**
 * 구매하기 - 상품 정보 컴포넌트(sales - goods information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import memberApi from '@/api/memberApi.js'
import salesApi from '@/api/salesApi.js'
import { log } from 'util'

// Store 임포트
import {mapState, mapMutations} from 'vuex'
import {salesMixin} from '@/mixins/sales.js'

export default {
    mixins: [salesMixin],
    components: {
        // PurchaseDetail
    },
    data() {
        return {
            submitState: false,
            orderData: null,
            paymentPrice: 0,
            totalPrice: 0,
            discountPrice: 0,
            orderId: '',
            currency: '',

            goodsThumnail: '',
            goodsName: '',

            ordererData: null,
            ordererEmail: '',
            ordererPhone: '',
            orderMemberName: '',

            ordererEmailText: null,
            ordererPhoneText: null
        }
    },
    mounted() {
        // this.$parent.setTopAppBarCloseOnly(this.$t('914'))
        this.fetchData()

        this.ordererEmailText = new MDCTextField(document.getElementById('ordererEmailText'))
        this.ordererPhoneText = new MDCTextField(document.getElementById('ordererPhoneText'))
        
        const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
            let button = new MDCRipple.attachTo(el)
            return button
        })

        // 자동 유효성 체크 제거(use native validation off)
        this.ordererEmailText.useNativeValidation = false
        this.ordererPhoneText.useNativeValidation = false

    },

    computed: {
        // 이메일 유효성 체크(validation email)
        ordererEmailInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('ordererEmail')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.ordererEmailText.valid === !returnValue ? '' : this.ordererEmailText.valid = !returnValue
            return returnValue
        },

        // 전화번호 유효성 체크(validation phone)
        ordererPhoneInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('ordererPhone')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.ordererPhoneText.valid === !returnValue ? '' : this.ordererPhoneText.valid = !returnValue
            return returnValue
        },
    },
    
    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('sales', ['SET_ORDERERENAME', 'SET_ORDEREREMAIL', 'SET_ORDEREREPHONE']),

        // 주문정보 API 호출(set order information)
        fetchData() {
            let params = this.setParams()
            let responseData = null
            salesApi.salesGoodsOrder(params).then((response) => {
                this.orderData = response.data.data
                
                this.paymentPrice = this.orderData.paymentPrice
                this.totalPrice = this.orderData.totalPrice
                this.discountPrice = this.orderData.discountPrice
                this.orderId = this.orderData.orderId
                this.currency = this.orderData.currency

                this.goodsThumnail = this.orderData.goods.image
                this.goodsName = this.orderData.goods.name

                let headerTitle = this.paymentPrice ? this.$t('451') : this.$t('914') // 구매 / 수강신청 정보
                this.$parent.setTopAppBarCustom({
                    leftBtnMode: 'close',
                    rightBtnMode: '',
                    title: headerTitle,
                    leftBtnMethod: () => {
                        this.$router.go(-1)
                    },
                    rightBtnMethod: '',
                })
                

            }).catch((err) => {
                responseData = err.response.data.meta
                this.$error({content: responseData.errMsg}).then(() => {})
            })

            // 최근 주문자 정보(get Recent orderer information)
            salesApi.salesOrdererRecent().then((response) => {
                this.ordererData = response.data.data                
                this.ordererEmail = this.ordererData.email
                this.ordererPhone = this.ordererData.phone

                this.ordererEmailText.value = this.ordererEmail
                this.ordererPhoneText.value = this.ordererPhone

            }).catch((err) => {})

            // 회원 정보(get member information)
            memberApi.getMemberInfo().then((response) => {
                responseData = response.data.data
                this.orderMemberName = responseData.name.fullName
            })
        },

        // 파라미터 설정(set parameter)
        setParams() {
            let params = {
                goodsId: this.$route.params.goodsid
            }
            return params
        },

        // 수강신청 API 호출(set enrollment)
        requestEnrolment() {
            let params = {}

            this.$validator.validateAll().then((resultValid) => {
                
                this.submitState = true
                if (resultValid) {
                    if (this.paymentPrice <= 0) {
                        params = {
                            orderId: this.orderId,
                            paymentMethod: '',
                            returnUrl: '',
                            ordererEmail: this.ordererEmail,
                            ordererPhone: this.ordererPhone,
                            informationConsent: true,
                            depositorName: this.orderMemberName,
                            data: {
                                DEPOSIT_ACCOUNT_ID: ''
                            }
                        }
                    }
                    
                    let responseData = null
                    salesApi.salesRequestPayment(params).then((response) => {
                        responseData = response.data.data
                        this.movePaymentResult()

                    }).catch((err) => {
                    })
                
                }
            })
        },
    },
}
</script>